import { PageInfo } from 'src/assets/types/interface/page-info.interface';

export async function buildNotificationsPageInfo(): Promise<PageInfo> {
  return {
    identification: '',
    title: 'Notificações',
    description: ' Listagem de notificações',
    pagesAbove: [
      {
        title: 'Home',
        url: '/home',
        description: 'Home',
      },
    ],
  };
}
